module.exports = __webpack_public_path__ + "static/media/card-meal-bg.51a2518e.png";